import Grid from '@mui/material/Unstable_Grid2'

import { memo } from 'react'
import { type TileEvent } from 'src/types'

const container = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

const colorTransitions = {
  transition: 'color .2s, background-color .2s',
  transitionTimingFunction: 'ease-out'
}

interface TileProps {
  light: number
  content: TileEvent | string
  handleClick: any
  tileSize?: number
  transparentBackground?: boolean
}

const Tile = memo(({ light, content, handleClick, tileSize = 32, transparentBackground = false }: TileProps) => {
  // @ts-expect-error
  const ui = content.ui ? content.ui : content

  const bgcolor = transparentBackground
    ? 'transparent'
    : ( 
        light < 1
          ? '#C9ADA7'
          : light < 2
            ? '#9A8C98'
            : light < 3
              ? '#4A4E69'
              : light < 4
                ? '#22223b'
                : 'black'
      )

  const color = (
    ui === 'P'
      ? 'white'
      : light < 2
        ? 'white'
        : light < 4
          ? '#9A8C98'
          : '#22223b'
  )


  const alwaysVisible = ['i', '↑', '↓', ' ', 'x']

  const visibleUI = (
    !ui || ui === '.' ? ' ' // if none or '.' renders empty tile
      : alwaysVisible.includes(ui) ? ui // if it's always visible
        // @ts-expect-error
        : !content.event
            ? ui
            : light < 4
              ? ui
              : light < 5
                ? '?'
                : ' '
  )

  return (
    <Grid xs={1} sx={{ bgcolor }} color={color} style={{ ...container, ...colorTransitions, height: `${tileSize}px`, width: `${tileSize}px` }} fontSize={`${tileSize - 6}px`} textAlign="center" onClick={handleClick} className="cell">
        <span style={{ lineHeight: 1, fontSize: `${tileSize - 6}px` }}>{visibleUI}</span>
    </Grid>
  )
})

export default Tile
